// src/utils/stampaNF.js
// Stampa / PDF di una richiesta NF — una sola versione per la pagina «Richiedi NF», la scheda
// della commessa e Centro Acquisti (W435: prima c'erano due copie quasi uguali).
// La descrizione mantiene gli a capo così come li ha scritti il richiedente.
import { dominioSito } from "./fornitore";
import { htmlArticoliNF, statoNf, etichettaNfOrdinata } from "./acquisti";

const esc = (t) => String(t ?? "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const dataIt = (iso) => (iso ? new Date(iso + "T00:00:00").toLocaleDateString("it-IT") : "—");

export function stampaNF(nf) {
  const win = window.open("", "_blank");
  if (!win) return false;
  const stato = statoNf(nf);
  const ordine = etichettaNfOrdinata(nf);
  win.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"/>
    <title>NF ${nf.numero ? `#${nf.numero}` : ""} — ${esc(String(nf.descrizione || "").split("\n")[0])}</title>
    <style>
      *{margin:0;padding:0;box-sizing:border-box;}
      body{font-family:Arial,sans-serif;font-size:12px;color:#111;padding:14mm 16mm;}
      @media screen{body{max-width:800px;margin:0 auto;background:#fff;box-shadow:0 2px 16px rgba(0,0,0,.08);}}
      @media print{.no-print-btn{display:none !important;}}
      @page{size:A4;}
      .hdr{border-bottom:3px solid #1e1b4b;padding-bottom:10px;margin-bottom:16px;display:flex;justify-content:space-between;align-items:flex-start;}
      .info{display:grid;grid-template-columns:repeat(2,1fr);gap:10px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:6px;padding:12px 16px;margin-bottom:16px;}
      .lbl{font-size:9px;color:#9ca3af;font-weight:700;text-transform:uppercase;display:block;margin-bottom:2px;}
      .val{font-size:12px;font-weight:600;}
      .footer{border-top:1px solid #e5e7eb;margin-top:16px;padding-top:8px;font-size:9px;color:#9ca3af;display:flex;justify-content:space-between;}
    </style></head><body>
    <div class="hdr">
      <div>
        <div style="font-size:16px;font-weight:800;color:#1e1b4b">RICHIESTA NF</div>
        <div style="font-size:18px;font-weight:900;color:#7c3aed;font-family:monospace">${nf.numero ? `#${nf.numero}` : "BOZZA"}</div>
      </div>
      <span style="padding:4px 12px;border-radius:20px;font-size:11px;font-weight:700;background:#eff6ff;color:#2563eb">${esc(stato)}</span>
    </div>
    <div class="info">
      <div><span class="lbl">Commessa</span><span class="val">${nf.codiceCommessa ? `[${esc(nf.codiceCommessa)}] ` : ""}${esc(nf.commessaNome || "—")}</span></div>
      <div><span class="lbl">Compilatore</span><span class="val">${esc(nf.compilatoreNome || "—")}</span></div>
      <div><span class="lbl">Data richiesta</span><span class="val">${dataIt(nf.dataRichiesta)}</span></div>
      <div><span class="lbl">Data consegna desiderata</span><span class="val">${dataIt(nf.dataConsegna)}</span></div>
      <div><span class="lbl">Fornitore</span><span class="val">${esc(nf.fornitoreId ? (nf.fornitoreNome || "—") : "N.D.")}</span></div>
      <div><span class="lbl">Luogo di consegna</span><span class="val">${esc(nf.destinazione || "—")}</span></div>
      ${nf.destinazione === "Misto" && nf.dettaglioDestinazioneMista ? `<div style="grid-column:1/-1"><span class="lbl">Dettaglio destinazioni</span><span class="val" style="white-space:pre-wrap;font-weight:400">${esc(nf.dettaglioDestinazioneMista)}</span></div>` : ""}
      <div><span class="lbl">Rif. Offerta</span><span class="val">${esc(nf.rifOfferta || "—")}</span></div>
      <div><span class="lbl">Urgenza</span><span class="val">${esc(nf.urgenza || "Normale")}</span></div>
      ${nf.allegatoOfferta?.url ? `<div style="grid-column:1/-1"><span class="lbl">Offerta allegata</span><a class="val" href="${esc(nf.allegatoOfferta.url)}" target="_blank">${esc(nf.allegatoOfferta.nome || "Apri il file")}</a></div>` : ""}
      ${ordine ? `<div style="grid-column:1/-1"><span class="lbl">Ordine</span><span class="val">${esc(ordine)}</span></div>` : ""}
    </div>
    <div style="background:#fef3c7;border:1px solid #fde68a;border-radius:6px;padding:10px 14px;margin-bottom:12px;">
      <span class="lbl" style="color:#92400e">Descrizione</span>
      <div style="font-weight:600;color:#92400e;margin-top:2px;white-space:pre-wrap">${esc(nf.descrizione || "")}</div>
    </div>
    ${htmlArticoliNF(nf)}
    ${nf.motivoUrgenza ? `<div style="background:#fef2f2;border:1px solid #fca5a5;border-radius:6px;padding:10px 14px;margin-bottom:12px;"><span class="lbl" style="color:#dc2626">Motivo urgenza</span><div style="color:#991b1b;margin-top:2px;white-space:pre-wrap">${esc(nf.motivoUrgenza)}</div></div>` : ""}
    ${nf.annullata ? `<div style="background:#f3f4f6;border:1px solid #d1d5db;border-radius:6px;padding:10px 14px;margin-bottom:12px;"><span class="lbl">Annullata</span><div style="margin-top:2px;white-space:pre-wrap">${esc(nf.motivoAnnullamento || "")}${nf.annullataDaNome ? ` — ${esc(nf.annullataDaNome)}` : ""}</div></div>` : ""}
    <div class="footer">
      <span>Generato da Nexiora — ${dominioSito()}</span>
      <span>Stampato il ${new Date().toLocaleDateString("it-IT")}</span>
    </div>
    </body></html>`);
  win.document.close();
  setTimeout(() => {
    if (win.closed) return;
    const btn = win.document.createElement("button");
    btn.textContent = "🖨️ Stampa";
    btn.className = "no-print-btn";
    btn.onclick = () => win.print();
    btn.style.cssText = "position:fixed;top:16px;right:16px;z-index:9999;padding:10px 20px;background:#7c3aed;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:700;cursor:pointer;font-family:Arial,sans-serif;box-shadow:0 4px 12px rgba(0,0,0,.2);";
    win.document.body.appendChild(btn);
  }, 50);
  return true;
}
